import { useState } from 'react';
import type { SubjectHistoryFeed } from '../../../../types';
import { useMoveHistoryItem } from '../../api/useMoveHistoryItem';

type Props = {
  item: SubjectHistoryFeed;
  onClose: () => void;
};

export function useMoveHistoryItemModal(props: Props) {
  const { mutateAsync, isPending } = useMoveHistoryItem();

  const [targetId, setTargetId] = useState<string | null>(null);
  const [serverError, setServerError] = useState<string | null>(null);

  async function handleConfirm() {
    if (!targetId) {
      setServerError('Choisissez le sous-sujet de destination.');
      return;
    }

    if (!props.item.id || !props.item.subject_id || !props.item.source) {
      setServerError('Cet élément ne peut pas être déplacé.');
      return;
    }

    if (props.item.source !== 'action' && props.item.source !== 'event') {
      setServerError('Seuls les actions et les rendez-vous peuvent être déplacés.');
      return;
    }

    setServerError(null);

    try {
      await mutateAsync({
        id: props.item.id,
        source: props.item.source,
        fromSubTopicId: props.item.subject_id,
        toSubTopicId: targetId,
      });
      props.onClose();
    } catch {
      setServerError("Le déplacement a échoué. Réessayez dans un instant.");
    }
  }

  function handleClose() {
    if (!isPending) {
      props.onClose();
    }
  }

  return {
    targetId,
    setTargetId,
    serverError,
    isPending,
    handleConfirm,
    handleClose,
  };
}
